"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.sort");
require("core-js/modules/es6.function.name");
var _customPage = require("@/api/customPage");
var _sortablejs = _interopRequireDefault(require("sortablejs"));
var _dataDisplay = _interopRequireDefault(require("./components/dataDisplay.vue"));
var _addModule = _interopRequireDefault(require("../components/addModule.vue"));
var _banner = _interopRequireDefault(require("../components/banner.vue"));
var _freePuzzle = _interopRequireDefault(require("../components/freePuzzle.vue"));
var _topModelPop = _interopRequireDefault(require("./components/topModelPop.vue"));
var _dataDisplayPop = _interopRequireDefault(require("./components/dataDisplayPop.vue"));
var _toolbar = _interopRequireDefault(require("./components/toolbar.vue"));
var _bannerListPop = _interopRequireDefault(require("../components/bannerListPop.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '',
  components: {
    topModelPop: _topModelPop.default,
    addModule: _addModule.default,
    banner: _banner.default,
    dataDisplay: _dataDisplay.default,
    freePuzzle: _freePuzzle.default,
    dataDisplayPop: _dataDisplayPop.default,
    toolbar: _toolbar.default,
    bannerListPop: _bannerListPop.default
  },
  props: {},
  data: function data() {
    return {
      loading: false,
      pageId: '',
      personalPageConfig: {},
      tableData: [],
      dataDisplay: [],
      pageName: ''
    };
  },
  computed: {},
  created: function created() {
    this.pageName = this.$route.query.activityName;
    this.pageId = this.$route.query.id;
    this.findModule();
  },
  mounted: function mounted() {
    this.drageBuff();
    // this.$refs.hotPicksPop.open()
  },
  methods: {
    goBack: function goBack() {
      this.$router.push({
        path: '/appNewRenovation/userCenter/index'
      });
    },
    refreshModule: function refreshModule(val) {
      console.log('刷新模块-------------------', val);
      this.tableData.map(function (i) {
        if (i.moduleId === val) {
          i.timestamp = new Date().getTime();
        }
      });
    },
    moduleUpdate: function moduleUpdate(val) {
      console.log(val, '===============');
      if (val.componentCode === 'dataDisplay') {
        this.$refs.dataDisplayPop.open({
          id: val.moduleId,
          componentSubcode: val.componentSubcode,
          componentCode: val.componentCode
        });
      } else {
        this.$refs.bannerListPop.open({
          name: val.remark ? "".concat(val.name, "\uFF08  ").concat(val.remark, "  \uFF09") : val.name,
          id: val.moduleId,
          componentSubcode: val.componentSubcode,
          componentCode: val.componentCode
        });
      }
    },
    addModule: function addModule() {
      this.$refs.addModule.open({
        // type: 'add',
        // title: ''
      });
    },
    del: function del(val) {
      var _this = this;
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _customPage.deleteSort)({
          moduleId: val.moduleId
        }).then(function (res) {
          if (res.data) {
            _this.$notify.success({
              title: '温馨提示',
              message: '操作成功'
            });
          }
          _this.findModule();
        });
      });
    },
    allChange: function allChange(val, text) {
      var _this2 = this;
      var obj = {
        moduleId: val.moduleId
      };
      obj[text] = val[text];
      console.log(obj);
      this.$confirm('是否确认编辑?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _customPage.updateStatus)(obj).then(function (res) {
          if (res.data) {
            _this2.$notify.success({
              title: '温馨提示',
              message: '操作成功'
            });
          }
          _this2.findModule();
        });
      }).catch(function () {
        if (val[text] === 1) {
          val[text] = 0;
        } else {
          val[text] = 1;
        }
      });
    },
    topConfig: function topConfig() {
      this.$refs.topModelPop.open(this.personalPageConfig);
    },
    findModule: function findModule() {
      var _this3 = this;
      this.loading = true;
      (0, _customPage.getModuleList)({
        pageId: this.pageId
      }).then(function (res) {
        _this3.loading = false;
        _this3.personalPageConfig = res.data.personalPageConfig;
        // this.tableData = []
        res.data.pageModuleList.map(function (i) {
          i['boole'] = false;
          i['timestamp'] = new Date().getTime();
          if (i.remark == null) {
            i.remark = '';
          }
        });
        _this3.tableData = res.data.pageModuleList;
        _this3.dataDisplay = res.data.pageModuleList.filter(function (i) {
          return i.componentCode === 'dataDisplay';
        });
        console.log(_this3.dataDisplay);
      }).catch(function () {
        _this3.loading = false;
      });
    },
    bothMouseOver: function bothMouseOver(val, itemIndex) {
      if (val.componentCode === 'floatingWindow' || val.componentCode === 'collection' || val.componentCode === 'marquee') {
        return;
      }
      val.boole = true;
      this.tableData.map(function (i, index) {
        if (itemIndex !== index) {
          i.boole = false;
        }
      });
    },
    bothMouseLeave: function bothMouseLeave() {
      this.tableData.map(function (i) {
        i.boole = false;
      });
    },
    bothClick: function bothClick(val) {
      this.moduleUpdate(val);
    },
    drageBuff: function drageBuff() {
      var _this4 = this;
      var tbody = document.querySelector('.my_table_name .el-table__body-wrapper tbody');
      _sortablejs.default.create(tbody, {
        handle: '.dg_div',
        animation: 150,
        onEnd: function onEnd(_ref) {
          var newIndex = _ref.newIndex,
            oldIndex = _ref.oldIndex;
          console.log(newIndex, oldIndex);
          console.log(_this4.tableData[newIndex].sort, _this4.tableData[oldIndex].moduleId);
          (0, _customPage.updateSort)({
            moduleId: _this4.tableData[oldIndex].moduleId,
            targetSort: _this4.tableData[newIndex].sort
          }).then(function (res) {
            if (res.data) {
              _this4.$notify.success({
                title: '温馨提示',
                message: '操作成功'
              });
            }
            _this4.$nextTick(function () {
              _this4.tableData = [];
              _this4.findModule();
            });
          });
        }
      });
    }
  }
};